// Proven posts: real Inspiration posts a host can follow from the moment box. Pure rules.
import type { PostTemplate } from '@str/shared';
import type { Kind } from './wizard';

export type ProvenPost = {
  id: string;
  handle: string;
  imageUrl: string | null;
  title: string;
  format: string;
  likes: number;
  views: number;
  template: PostTemplate | null;
};

const count = (n: number) =>
  n >= 1_000_000
    ? `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
    : n >= 1000
      ? `${(n / 1000).toFixed(n >= 10_000 ? 0 : 1).replace(/\.0$/, '')}k`
      : String(n);

/** What a proven post is shown with: views when there are any, otherwise likes. */
export function provenStat(p: Pick<ProvenPost, 'likes' | 'views'>): string {
  return p.views > 0 ? `${count(p.views)} views` : `${count(p.likes)} likes`;
}

/** The posts worth offering: with a picture and a form to follow, reels only for a reel. */
export function offerable(posts: ProvenPost[], kind: Kind): ProvenPost[] {
  return posts.filter(
    (p) => !!p.imageUrl && !!p.template && (kind === 'Post' || p.format === 'Reel'),
  );
}
